import getSliceName from '@om-fe/core/utils/get-slice-name';
import { DisciplinesType } from '@om-fe/models';
import {
    TOP_BETS_TIME_RANGE_PATH,
    TOP_BETS_TIME_RANGE_LOCATION_PATH,
    TOP_BETS_TIME_RANGE_CATEGORY_PATH,
    TopBetsTimeRangeTopic,
    slicePrefix,
} from './time-range-nav.constants';

export function getTopBetsTimeRangeSliceName(instanceId: string): string {
    return getSliceName(slicePrefix, instanceId);
}

export function getTopBetsTimeRangeTopic(
    disciplineId: string,
    locationId?: string,
    categoryId?: string,
): TopBetsTimeRangeTopic {
    const timezone: number = (new Date()).getTimezoneOffset();
    const timezoneOffset: number = timezone !== 0 ? timezone * -1 : timezone;

    if (disciplineId === DisciplinesType.ElectronicSports && locationId) {
        return {
            path: TOP_BETS_TIME_RANGE_PATH,
            params: {
                disciplineId: locationId,
                offsetTime: timezoneOffset,
            },
        };
    } else {
        if (categoryId) {
            return {
                path: TOP_BETS_TIME_RANGE_CATEGORY_PATH,
                params: {
                    disciplineId,
                    categoryId,
                    offsetTime: timezoneOffset,
                },
            };
        } else if (locationId) {
            return {
                path: TOP_BETS_TIME_RANGE_LOCATION_PATH,
                params: {
                    disciplineId,
                    locationId,
                    offsetTime: timezoneOffset,
                },
            };
        } else {
            return {
                path: TOP_BETS_TIME_RANGE_PATH,
                params: {
                    disciplineId,
                    offsetTime: timezoneOffset,
                },
            };
        }
    }
}
